/* v8 ignore start */
import {Component, ErrorInfo} from "react";

type TErrorBoundaryProps = {
  onError(error: Error, errorInfo: ErrorInfo): void;
  children?: React.ReactNode;
};

interface IErrorBoundaryState {
  error?: Error;
}

class ErrorBoundary extends Component<TErrorBoundaryProps, IErrorBoundaryState> {
  public constructor(props: TErrorBoundaryProps) {
    super(props);
    this.state = {};
  }

  public static getDerivedStateFromError(error: Error) {
    return {error};
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.props.onError(error, errorInfo);
  }

  public render() {
    if (this.state.error) return null;

    return this.props.children;
  }
}

export default ErrorBoundary;
/* v8 ignore stop */
